const TOKEN_KEY = "snail_token";

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(t: string): void {
  localStorage.setItem(TOKEN_KEY, t);
}
export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

export async function apiFetch(path: string, options?: RequestInit): Promise<any> {
  const token = getToken();
  const res = await fetch(`/api${path}`, {
    ...options,
    headers: {
      ...(options?.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  if (res.status === 401) {
    clearToken();
    window.location.reload();
    throw new Error("Unauthorized");
  }
  if (!res.ok) {
    // Keep the "API <status>" prefix (matched by describeError) but carry the
    // server's human-readable detail so refusals like the one-group wall can
    // surface instead of being flattened to a bare status code.
    const detail = (await res.json().catch(() => null))?.detail;
    throw new Error(detail ? `API ${res.status}: ${detail}` : `API ${res.status}`);
  }
  return res.json();
}
